<button (click)="onClick.emit()"
	class="toggle-password-visibility-button"
	[matTooltip]="getTooltipText()"
	[attr.aria-label]="getTooltipText()"
	[attr.aria-pressed]="!passwordHidden"
	type="button">
	<i class="icon-btn" [ngClass]="{
		'ficon-app-preview-off': passwordHidden,
		'ficon-app-preview': !passwordHidden
	}">
	</i>
</button>
